var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "container has-text-centered opaque",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "hero one is-dark",
    staticStyle: {
      "margin-top": "25px",
      "border-radius": "5px"
    }
  }, [_c('div', {
    staticClass: "hero-body"
  }, [(!_vm.contactSuccess) ? _c('div', {
    staticClass: "columns is-vcentered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control has-icons-left is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }],
    staticClass: "input is-flat required email",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-outlined",
    class: {
      'is-loading': _vm.isSendingContactUsEmail
    },
    on: {
      "click": function($event) {
        _vm.sendContactMessage(_vm.contact)
      }
    }
  }, [_vm._v("Reach Out")])])])])]) : _vm._e(), _vm._v(" "), (_vm.contactSuccess) ? _c('div', {
    staticClass: "columns is-vcentered"
  }, [_vm._m(2)]) : _vm._e()])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "field crud-buttons is-grouped is-pulled-right"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link hide-mobile",
    on: {
      "click": function($event) {
        _vm.openEmailModal()
      }
    }
  }, [_vm._v("\n            Email (PDF)\n            "), _c('i', {
    staticClass: "fa fa-lg fa-envelope-open",
    staticStyle: {
      "padding-left": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-desktop",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": function($event) {
        _vm.openEmailModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-envelope-open"
  })])]), _vm._v(" "), _c('span', [_c('a', {
    ref: "pdf",
    attrs: {
      "download": _vm.fileName,
      "href": _vm.pdflink
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-mobile",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_vm._v("\n            Download (PDF)\n            "), _c('i', {
    staticClass: "fa fa-lg fa-download",
    staticStyle: {
      "padding-left": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-desktop",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-download"
  })])])]), _vm._v(" "), _vm._m(4)]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('Accord24', {
    attrs: {
      "accord24": _vm.accord24,
      "requestViewer": true
    }
  }), _vm._v(" "), _c('Accord24', {
    ref: "accord",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "accord24": _vm.accord24,
      "readonly": true
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showEmailModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Email Certificate")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.closeEmailModal()
      }
    }
  })]), _vm._v(" "), (!_vm.emailSuccess) ? _c('div', [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("To")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailData.to),
      expression: "emailData.to"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter a comma separated list of email address"
    },
    domProps: {
      "value": (_vm.emailData.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailData, "to", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.emailInvalidTo) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n                  Valid email address is required\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("CC")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailData.cc),
      expression: "emailData.cc"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter a comma separated list of email address"
    },
    domProps: {
      "value": (_vm.emailData.cc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailData, "cc", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.emailInvalidCc) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n                  Valid email address is required\n                ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-paperclip"
  }), _vm._v(" " + _vm._s(_vm.getAttachmentName()))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailData.message),
      expression: "emailData.message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Enter message"
    },
    domProps: {
      "value": (_vm.emailData.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailData, "message", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), (_vm.emailError) ? _c('section', {
    staticClass: "modal-card-body"
  }, [_c('hr'), _vm._v(" Error sending email! Please try again or download PDF and send externally.\n          "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-success",
    class: {
      'is-loading': _vm.isSendingEmail
    },
    on: {
      "click": function($event) {
        _vm.sendEmailMessage(_vm.emailData)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.closeEmailModal()
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (_vm.emailSuccess) ? _c('div', [_vm._m(5), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.closeEmailModal()
      }
    }
  }, [_vm._v("Close")])])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-half"
  }, [_c('h3', {
    staticClass: "title is-6"
  }, [_c('strong', [_vm._v("If you find this fillable Certificate of Property Insurance form valuable, please reach out to us. We would\n                  "), _c('u', [_vm._v("love")]), _vm._v(" to hear from you.")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column has-text-centered"
  }, [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v("Thank you for your support!")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v("Online Fillable Certificate of Property Insurance")]), _vm._v(" "), _c('hr'), _vm._v(" While we offer a full featured EOI management system, you can use the following free, online fillable Certificate\n        of Property Insurance form to respond to Evidence of Insurance requests as well. Once you complete the form below,\n        you can either download a PDF certificate directly or email the certificate.\n        "), _c('h3', {
    staticClass: "title is-6",
    staticStyle: {
      "margin-top": "18px"
    }
  }, [_vm._v("Guidelines for completing the form")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("We recommend to include all insurers and policies, not limited to just property insurance. This can include\n              Commercial General Liability, Flood, Employee Theft and Umbrella insurance.\n            ")]), _vm._v(" "), _c('li', [_vm._v("Include a good description of the properties and buildings covered by the insurance in the LOCATION OF PREMISES/DESCRIPTION\n              OF PROPERTIES field.\n            ")]), _vm._v(" "), _c('li', [_vm._v("Use the ADDITIONAL REMARKS page to further elaborate about properties and coverage.\n            ")]), _vm._v(" "), _c('li', [_vm._v("For more guidance, have a look at this\n              "), _c('a', {
    attrs: {
      "href": "/static/InsuranceCertificate.pdf",
      "title": "Sample Certificate of Property Insurance",
      "alt": "Sample Certificate of Property Insurance"
    }
  }, [_vm._v("Sample Certificate of Property Insurance")]), _vm._v(".\n            ")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section hide-mobile"
  }, [_c('h3', {
    staticClass: "title is-6"
  }, [_vm._v("Certificate of Property Insurance Form")]), _vm._v(" "), _c('hr')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._v("\n          Thank you, your email has been sent.\n          "), _c('br'), _vm._v(" "), _c('br')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d1c9597","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/request/PublicRequest.vue
// module id = XQW4
// module chunks = 1